import React, {
    useContext,
    useMemo,
} from 'react';

import { Mobile } from 'app/components/Responsive';

import LandingMobileSiteNav from '../../../../common/components/LandingMobileSiteNav';

import { UserContext } from './UserProvider';


export default function NyMobileSiteNav() {
    const userContext = useContext(UserContext);

    const {
        isAuthed,
        userQuery: rawUserQuery,
        onClickQuit,
    } = userContext;

    const userQuery = useMemo(() => ({
        user: rawUserQuery.data.user,
    }), [rawUserQuery]);

    return (
        <Mobile isWideMobile>
            <LandingMobileSiteNav
                isFillerNeeded
                isAuthed={isAuthed}
                userQuery={userQuery}
                onClickQuit={onClickQuit}
            />
        </Mobile>
    );
}
